var _path, _path2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0.5C92.8609 0.5 119.5 27.1391 119.5 60C119.5 92.8609 92.8609 119.5 60 119.5C27.1391 119.5 0.5 92.8609 0.5 60C0.5 27.1391 27.1391 0.5 60 0.5Z",
    fill: "#CFE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0.5C92.8609 0.5 119.5 27.1391 119.5 60C119.5 92.8609 92.8609 119.5 60 119.5C27.1391 119.5 0.5 92.8609 0.5 60C0.5 27.1391 27.1391 0.5 60 0.5Z",
    stroke: "#CFE2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_313_14322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 28,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_313_14322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 84C39.8667 84 38.6111 83.4778 37.5667 82.4333C36.5222 81.3889 36 80.1333 36 78.6667V41.3333C36 39.8667 36.5222 38.6111 37.5667 37.5667C38.6111 36.5222 39.8667 36 41.3333 36H78.6667C80.1333 36 81.3889 36.5222 82.4333 37.5667C83.4778 38.6111 84 39.8667 84 41.3333V78.6667C84 80.1333 83.4778 81.3889 82.4333 82.4333C81.3889 83.4778 80.1333 84 78.6667 84H41.3333ZM41.3333 78.6667H78.6667V41.3333H41.3333V78.6667ZM46.6667 73.3333H73.3333C73.8667 73.3333 74.2667 73.0889 74.5333 72.6C74.8 72.1111 74.7556 71.6444 74.4 71.2L67.0667 61.4C66.8 61.0444 66.4444 60.8667 66 60.8667C65.5556 60.8667 65.2 61.0444 64.9333 61.4L58 70.6667L53.0667 64.0667C52.8 63.7111 52.4444 63.5333 52 63.5333C51.5556 63.5333 51.2 63.7111 50.9333 64.0667L45.6 71.2C45.2444 71.6444 45.2 72.1111 45.4667 72.6C45.7333 73.0889 46.1333 73.3333 46.6667 73.3333Z",
    fill: "#6C757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompany);
export default __webpack_public_path__ + "static/media/default-company.226ec30ebb1618f63ff1bf997e51f8dd.svg";
export { ForwardRef as ReactComponent };